const listicleGenUrl = import.meta.env.VITE_LISTICLE_GEN_FUNCTION_URL;

if (!listicleGenUrl) {
    throw new Error("Missing required environment variable: VITE_LISTICLE_GEN_FUNCTION_URL");
}

export const config = {
    listicleGenUrl
};
